import { Button, ModalBox, PriceString, Skeleton, Table, useModalContext, } from '@fourthwall/components';
import React from 'react';
import { fixRounding } from '@fourthwall/utils/dist/number';
import { usePriceRatesQuery } from '../../hooks/usePriceRatesQuery';
import { currencyDecimalPlaces } from '../../providers/TierProvider/consts';
import { getExchangeRate } from '../../utils';
import * as S from './styled';
export const CurrenciesUpdateModal = ({ tier, price, enabledCurrencies, onSave }) => {
    const modal = useModalContext();
    const { priceRatesQuery } = usePriceRatesQuery([{ usd_amount: fixRounding((parseFloat(price) || 1) * 100, 2) }], {
        cacheTime: 0,
        staleTime: Infinity,
    });
    const getTableData = () => {
        if (!enabledCurrencies)
            return [];
        if (tier && !('pricesAutomaticallyConverted' in tier))
            return [];
        return enabledCurrencies.map((currency) => {
            const currencyLowercase = currency.toLowerCase();
            const amount = tier.variants.monthly.amounts[currencyLowercase].amount;
            const currentRate = amount / 10 ** currencyDecimalPlaces[currencyLowercase];
            const newRate = priceRatesQuery.data ? (getExchangeRate(currency, priceRatesQuery.data)) : (React.createElement(Skeleton.Shape, { height: 21, width: 140 }));
            return {
                currency,
                currentRate,
                newRate,
            };
        });
    };
    return (React.createElement(ModalBox, { size: "medium", title: React.createElement(React.Fragment, null,
            "Update currency conversion for ",
            React.createElement(PriceString, { value: price }),
            " per month"), buttons: [
            React.createElement(Button, { label: "Cancel", appearance: "secondary", fullWidth: true, onClick: modal.close }),
            React.createElement(Button, { label: "Update", appearance: "primary", fullWidth: true, loading: !priceRatesQuery.data, onClick: () => {
                    if (!priceRatesQuery.data)
                        return;
                    modal.close();
                    onSave(priceRatesQuery.data);
                } }),
        ], onClose: modal.close },
        React.createElement(S.TableContainer, null,
            React.createElement(Table, { data: getTableData(), headers: [
                    {
                        id: 'currency',
                        label: 'Currecy',
                        render: ({ currency }) => React.createElement(S.CurrencyContainer, null, currency),
                    },
                    {
                        id: 'currentRate',
                        label: 'Current value',
                        render: ({ currentRate }) => currentRate,
                    },
                    {
                        id: 'newRate',
                        label: 'New value',
                        render: ({ newRate }) => React.createElement(S.Bold, null, newRate),
                    },
                ], minWidth: 0, compact: true }))));
};
